import { render, staticRenderFns } from "./series.vue?vue&type=template&id=2b7659ca&scoped=true"
import script from "./series.vue?vue&type=script&lang=js"
export * from "./series.vue?vue&type=script&lang=js"
import style0 from "./series.vue?vue&type=style&index=0&id=2b7659ca&lang=scss"
import style1 from "./series.vue?vue&type=style&index=1&id=2b7659ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7659ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b7659ca')) {
      api.createRecord('2b7659ca', component.options)
    } else {
      api.reload('2b7659ca', component.options)
    }
    module.hot.accept("./series.vue?vue&type=template&id=2b7659ca&scoped=true", function () {
      api.rerender('2b7659ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cont/series.vue"
export default component.exports